/**
 * @param {string} input
 * @returns {{ videoId: string, privacyHash?: string }}
 */
export function parseVimeoUrl(input) {
  const value = String(input || "").trim();
  const match = value.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([a-f0-9]+))?/i);
  if (!match) {
    return { videoId: "" };
  }

  return {
    videoId: match[1],
    privacyHash: match[2] || undefined,
  };
}

/** @param {string} input Share or player URL */
export function vimeoEmbedUrl(input) {
  const { videoId, privacyHash } = parseVimeoUrl(input);
  if (!videoId) {
    return "";
  }

  const url = new URL(`https://player.vimeo.com/video/${videoId}`);
  url.searchParams.set("title", "0");
  url.searchParams.set("byline", "0");
  url.searchParams.set("portrait", "0");
  if (privacyHash) {
    url.searchParams.set("h", privacyHash);
  }

  return url.toString();
}

/** @param {string} input */
export function vimeoWatchUrl(input) {
  const { videoId, privacyHash } = parseVimeoUrl(input);
  if (!videoId) {
    return input;
  }

  return privacyHash
    ? `https://vimeo.com/${videoId}/${privacyHash}`
    : `https://vimeo.com/${videoId}`;
}
